//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import * as s from "./SegmentedBar.styles";
import ReactTooltip from "react-tooltip";
import { IProps, IState, ISegment } from "./SegmentedBar.d";

//////////////////
// COMPONENT
//////////////////
export class SegmentedBar extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      ready: !this.props.animateIn,
    };
  }

  public componentDidMount() {
    if (this.state.ready) {
      return;
    }
    setTimeout(() => {
      this.setState({ ready: true });
    }, 0);
  }

  private renderSegment = (total: number, segment: ISegment, i: number) => {
    const percentWidth = this.state.ready ? segment.value / total : 0;
    const segmentStyle = s.genSegment(segment.color, percentWidth, segment.isInset);

    if (!segment.tipLabel) {
      return <div key={i} style={segmentStyle} />;
    } else {
      const toolTipId = `seg_${percentWidth}_${Math.random().toString(36).substring(2)}`;
      return (
        <div key={i} style={segmentStyle} data-tip data-for={toolTipId}>
          <ReactTooltip id={toolTipId}>{segment.tipLabel}</ReactTooltip>
        </div>
      );
    }
  };

  public render() {
    const { segments, style } = this.props;
    const total = segments.reduce((accum, next) => accum + next.value, 0);
    return (
      <div style={{ ...s.container, ...style }}>
        {segments.map((segment, i) => {
          return this.renderSegment(total, segment, i);
        })}
      </div>
    );
  }
}
